import { css } from '@mui/material';

export const useStyles = () => {
  return {
    cardContainer: (isLoading: boolean) => css`
      display: flex;
      flex-direction: column;
      gap: 20px;
      justify-content: space-between;
      background: #fff;
      border-radius: 20px;
      padding: 24px;
      box-shadow: 0 0 20px 0 #0000000d;
      opacity: ${isLoading ? 0.4 : 1};
    `,

    loader: css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    `,
    tooltip: css``,

    tooltipIcon: css`
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-left: 8px;
      cursor: pointer;
    `,

    empty: css`
      padding: 20px;
      background: #fafafa;
      border-radius: 16px;
    `,
    content: css`
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 150px;
    `,
  };
};
